import { gtmPush, getErrorPrefix } from './common-utils.js';

export const resetErrors = () => {
	const errorWrapper = document.getElementById('product-error');
	const errorNodes = errorWrapper.querySelectorAll('p') || [];

	errorNodes.forEach((node) => {
		node.remove();
	})
}

const showError = (errorMessage, errorId) => {
	const errorWrapper = document.getElementById('product-error');
	const msgElement = document.createElement('p');

	msgElement.classList.add('slf__warning')
	msgElement.id = errorId;
	msgElement.innerHTML = errorMessage;

	errorWrapper.append(msgElement);
}

export default (errs, url) => {
	const errPrefix = getErrorPrefix(url);

	resetErrors();

	errs.forEach((err, i) => {
		switch (true) {
			case (err === 'malformed'):
				showError('Something went wrong, please try again.', `${errPrefix}-${i + 1}`);
				break;
			case (err === 'Email exists'):
				showError('An account already exists with that email. Please <a href="https://service.sumologic.com">sign in</a>.', `${errPrefix}-${i + 1}`);
				break;
			case (err === 'email must be a valid email'):
			case (err === 'Invalid email address'):
				showError('Please check your email address and try again.');
				break;
			case (err === 'PasswordReusedError'):
				showError('Passwords cannot be reused, please try a new password.');
				break;
			case (err === 'Duplicate organization name'):
				showError('That organization name is taken. Please try again.');
				break;
			default:
				showError('Something went wrong');
				break;
		}
	})

	return errs
}
